import React, { useState } from 'react';
import { Container } from '@mui/material';
import InputForm from '../components/InputForm';
import ResultDisplay from '../components/ResultDisplay';
import { calculateSalary } from '../utils/calculations';
import { useLimits } from '../utils/limitsContext';

const CalculationPage: React.FC = () => {
  const [result, setResult] = useState<any>(null);
  const { limits } = useLimits();

  const handleCalculate = (inputData: {
    monthlySalary: number;
    additionalMonths: number;
    bonusMonths: number;
    monthlySubsidy: number;
    additionalTaxFree?: number;
    housingFundRate: number;
    province: string;
    city: string;
  }) => {
    const calculationResult = calculateSalary(inputData, limits);
    setResult(calculationResult);

    const historyData = JSON.parse(localStorage.getItem('calculationHistory') || '[]');
    historyData.push({
      id: crypto?.randomUUID ? crypto.randomUUID() : String(Date.now()),
      createdAt: new Date().toISOString(),
      input: inputData,
      result: calculationResult,
      limitsVersion: limits.version,
    });
    localStorage.setItem('calculationHistory', JSON.stringify(historyData));
  };

  return (
    <Container>
      <InputForm onCalculate={handleCalculate} />
      <ResultDisplay result={result} />
    </Container>
  );
};

export default CalculationPage;